import React, { useCallback, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { FullscreenLoading } from '..';
import { StudentContext } from '../../contexts';
import { useGetStudentResumeById } from '../../hooks/gql/useGetStudentResumeById';

export const GenerateTailoredDocumentRoute: React.FC = () => {
  const history = useHistory();
  const stdCtx = useContext(StudentContext);

  const [generateResume] = useGetStudentResumeById({
    onCompleted: useCallback((data) => {
      if (data && data.getStudentResumeById) {
        // Open the DOCX file URL in a new tab
        window.open(data.getStudentResumeById, '_blank');
        history.goBack();
      }
    }, [history]),
    onError: useCallback((error) => {
      history.goBack();
    }, [history])
  });

  useEffect(() => {
    if (stdCtx) {
      void generateResume({
        variables: {
          userId: stdCtx.student.id
        }
      });
    } else {
      console.warn('[GenerateTailoredDocumentRoute] No student context available');
    }
  }, [stdCtx, generateResume]);

  return <FullscreenLoading text="Generating file..." />;
};
